module.exports = __webpack_public_path__ + "img/album14_03.c73dae0a.jpg";